import { configureStore } from "@reduxjs/toolkit";
import { routerMiddleware } from "./modules/router/routerAdapter";
import reducer from "./modules";
import { enableReducerHotReload } from "./store.devtools";
import { analyticsMiddleware } from "./middleware/analytics";
import { createFacetListeners } from "./modules/facets/listeners";
import { searchListenersMiddleware } from "./modules/search/domains/store/listeners";

export default (history, state) => {
  const store = configureStore({
    reducer: reducer(history),
    preloadedState: state,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(
        routerMiddleware(history),
        analyticsMiddleware,
        createFacetListeners().middleware,
        searchListenersMiddleware,
      ),
  });

  enableReducerHotReload(store, history);

  return store;
};
